module.exports = __webpack_public_path__ + "static/img/998-20237451_Easergy-P3_GMA_US_Social-Media_1200x1200_V2.ffe0b1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/998-20237451_Easergy-P3_GMA_US_Social-Media_1200x1200_V2.jpg
// module id = n4LV
// module chunks = 0